import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/_models';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  classToggle: string;
  timesVisible: string;
  barsVisible: string;
  iconMenu: string;
  currentUser = {} as User;
  exibirMenuAprovacaoComercial = {} as boolean;

  constructor(public router: Router) { }

  ngOnInit() {
    this.classToggle = 'active';
    this.iconMenu = 'dehaze';
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.exibirMenuAprovacaoComercial = this.currentUser.visualizarAprovacaoComercial;
  }

  toggleMenu(): void {
    if (this.classToggle === '') {
      this.classToggle = 'active';
      this.iconMenu = 'dehaze';
    } else {
      this.classToggle = '';
      this.iconMenu = 'close';
    }
  }

  setActive() {

  }
}
